<script setup lang="ts">
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

// ダミーのGoogleフォームURL（後で実物のURLに差し替え可能）
const GOOGLE_FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLSdXACahEvURtpZ3e7kSLzw2B6Pqn0u7kJxDNj__HeNiNlCL-g/viewform?usp=header";
</script>

<template>
    <div class="content-container contact-view">
        <h1>{{ t('contact.title') }}</h1>
        <p class="description">{{ t('contact.description') }}</p>

        <div class="form-wrapper">
            <iframe :src="GOOGLE_FORM_URL" width="100%" height="800" frameborder="0" marginheight="0" marginwidth="0">
                {{ t('contact.form_loading') }}
            </iframe>
        </div>

        <div class="back-link-container">
            <router-link to="/" class="back-link">{{ t('contact.back_to_home') }}</router-link>
        </div>
    </div>
</template>

<style scoped>
@import '@/assets/text-page.css';

.contact-view {
    max-width: 800px;
    margin: 0 auto;
    padding: 2rem 1rem;
}

.description {
    margin-bottom: 2rem;
    text-align: center;
    color: #666;
}

.form-wrapper {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    overflow: hidden;
    margin-bottom: 2rem;
}

.back-link-container {
    text-align: center;
    margin-top: 2rem;
}

.back-link {
    display: inline-block;
    padding: 0.8rem 2rem;
    background-color: #f0f2f5;
    color: #2c3e50;
    text-decoration: none;
    border-radius: 8px;
    transition: background-color 0.3s;
}

.back-link:hover {
    background-color: #e2e6ea;
}
</style>
